import React, { useState } from 'react';
import { MdSearch } from 'react-icons/md';
import './ShopSearch.css';

const ShopSearch = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/^\s+/g, '');
    setSearchQuery(value);
  };
  return (
    <div className="flex flex-ai-c search">
      <MdSearch size={16} />
      <input
        type="text"
        placeholder="search store"
        onChange={handleInputChange}
        value={searchQuery}
      />
    </div>
  );
};

export default ShopSearch;
